import { render, staticRenderFns } from "./searchImageDetailTray.vue?vue&type=template&id=0a8bafe8&scoped=true&"
import script from "./searchImageDetailTray.vue?vue&type=script&lang=js&"
export * from "./searchImageDetailTray.vue?vue&type=script&lang=js&"
import style0 from "./searchImageDetailTray.vue?vue&type=style&index=0&id=0a8bafe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8bafe8",
  null
  
)

export default component.exports